    <div class="modal-header modal-auction">
        <button *ngIf="isModal" type="button" class="close pull-right" aria-label="Close" (click)="closeAuctionInfoModal()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100 pl-3" id="myModalLabel">Auction Vehicle Information</h4>
      </div>
      <div class="modal-body p-4 mt-3 mb-3">
             <div class="row">
                  <div class="col-md-12 col-xs-12">
                   <mat-accordion class="card-auction">

                          <!-- <mat-expansion-panel (opened)="panelOpenState = true" *ngFor="let panel of auctionVehicleInfo | keyvalue"
                                               (closed)="panelOpenState = false" hideToggle="true" [expanded]="false"> -->
                         <mat-expansion-panel *ngFor="let panel of auctionVehicleInfo | keyvalue" [expanded]="false">
                             <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{addSpaceAfterCapitalizedLetters(panel.key)}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="row" *ngFor="let item of panel.value">
                            <ng-container *ngIf="getColumnItems(item, 'left').length === 1; else multiColumn">
                                <div class="col-md-12 col-xs-12">
                                    <!-- Terms & Conditions: render with line breaks -->
                                    <ng-container *ngIf="panel.key === 'TermsAndConditions'; else plainText">
                                        <p style="white-space: pre-wrap">{{ getColumnItems(item, 'left')[0].value }}</p>
                                    </ng-container>
                                    <ng-template #plainText>
                                        <p>{{ getColumnItems(item, 'left')[0].value }}</p>
                                    </ng-template>
                                </div>
                              </ng-container>
                              <ng-template #multiColumn>
                                <div class="col-md-6 col-xs-12">
                                  <ul class="list-group list-auction list-group-flush">
                                    <li class="list-group-item" *ngFor="let keyValuePair of getColumnItems(item, 'left')">
                                      <h2>{{ keyValuePair.key }}</h2>
                                      <span class="text-right">{{ keyValuePair.value }}</span>
                                    </li>
                                  </ul>
                                </div>
                                <div class="col-md-6 col-xs-12">
                                  <ul class="list-group list-auction list-group-flush">
                                    <li class="list-group-item" *ngFor="let keyValuePair of getColumnItems(item, 'right')">
                                      <h2>{{ keyValuePair.key }}</h2>
                                      <span class="text-right">{{ keyValuePair.value }}</span>
                                    </li>
                                  </ul>
                                </div>
                              </ng-template>
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                  </div>
                </div>
      </div>
      <div *ngIf="isModal" class="modal-footer text-center">
        <button type="button" color="secondary" class="btn btn-auction" aria-label="Close" (click)="closeAuctionInfoModal()">Close</button>
      </div>